module.exports = __webpack_public_path__ + "static/media/todeal2@2x.f5b1aa9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/activity_100/todeal2@2x.png
// module id = 1151
// module chunks = 0